module.exports = __webpack_public_path__ + "static/media/future.56d75087.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tiendas/roadmap/future.png
// module id = 2189
// module chunks = 0